export default __webpack_public_path__ + "static/media/Lorena_1.178dcbee.webp";